export const status = {
  inTransit: "in-transit",
  received: "received",
  rejected: "rejected",
  cancelled: "cancelled",
};

export const batteryMovementStatus = {
  inTransit: {
    value: status.inTransit,
    label: "In Transit",
    color: "warning",
  },
  received: {
    value: status.received,
    label: "Received",
    color: "success",
  },
  rejected: {
    value: status.rejected,
    label: "Rejected",
    color: "error",
  },
  cancelled: {
    value: status.cancelled,
    label: "Cancelled",
    color: "error",
  },
};

export const batteryMovementStatusOptions = [
  {
    value: batteryMovementStatus.inTransit.value,
    label: batteryMovementStatus.inTransit.label,
  },
  {
    value: batteryMovementStatus.received.value,
    label: batteryMovementStatus.received.label,
  },
  {
    value: batteryMovementStatus.rejected.value,
    label: batteryMovementStatus.rejected.label,
  },
  {
    value: batteryMovementStatus.cancelled.value,
    label: batteryMovementStatus.cancelled.label,
  },
];
